'use client'

import DOMPurify, { type Config } from 'dompurify'

/**
 * Browser-only sanitizer. Safe to import from Client Components: `dompurify` has no jsdom
 * and is bundled instead of loaded as a serverless external.
 * During SSR this is a no-op so the server bundle never needs a window / JSDOM.
 */
export function sanitizeHtml(dirty: string, config?: Config): string {
	if (typeof window === 'undefined') {
		return dirty
	}

	return DOMPurify.sanitize(dirty, config)
}
